<!-- =========================================================================================
  File Name: DataViewCamSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4 style="word-break: normal;">{{ Object.entries(this.data).length === 0 ? "ADD NEW" : "EDIT" }} {{ $t('user.title') }}</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">
          <!-- Product Image -->
        <template >
          <div class="contained-example-container">
            <div id="div-with-loading" class="vs-con-loading__container">
          <!-- Image Container -->
          <div class="img-container w-64 mx-auto flex items-center justify-center vs-con-loading__container" id="div-with-loading">
            <img v-if="ImgName" :src="dataImg" class="responsive">
          </div>
          </div>
            </div>

          <!-- Image upload Buttons -->
          <div class="modify-img flex justify-between mt-5">
            <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*">
            <vs-button class="mr-4" type="flat" @click.native="$refs.updateImgInput.click()">{{this.ImgName == null ? "Upload" : "Update" }} {{ $t('user.add.image') }}</vs-button>
            <vs-button v-if="ImgName!==null" type="flat" color="#999" @click.native="ImgName = null , dataImg = null">Remove Image</vs-button>
          </div>
        </template>
        <!-- Username -->
        <vs-input :label="$t('user.add.user_name')"  v-model="dataUserName"  @input="checkUserNameExcepteId" class="mt-5 w-full" name="Username" v-validate="'alpha_num|required'"  />
        <span class="text-danger text-sm" v-show="errors.has('Username')">{{ errors.first('Username') }}</span>
        <span class="text-danger text-sm" v-if="UserDuplicate>0">UserName has  already been taken!</span>
        <span class="text-danger text-sm" v-if="alphanumeric>0 && dataUserName!=''">Input Shoud be Alpha Numaric</span>

        <!-- FIRST NAME -->
        <vs-input :label="$t('user.add.first_name')" v-model="dataFirstName" class="mt-5 w-full" :name="$t('user.add.first_name')" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has($t('user.add.first_name'))">{{ errors.first($t('user.add.first_name')) }}</span>
             <!-- Middle NAME -->
        <vs-input :label="$t('user.add.middle_name')"  v-model="dataMiddleName" class="mt-5 w-full" :name="$t('user.add.middle_name')" />

        <!-- LAST NAME -->
        <vs-input :label="$t('user.add.last_name')" v-model="dataLastName" class="mt-5 w-full" :name="$t('user.add.last_name')" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has($t('user.add.last_name'))">{{ errors.first($t('user.add.last_name')) }}</span>

        <!-- EMAIL -->
        <vs-input :label="$t('user.add.email')" v-model="dataEmail" @input="acceptEmail" class="mt-5 w-full" :name="$t('user.add.email')" v-validate="'email|required'" />
        <span class="text-danger text-sm" v-show="errors.has($t('user.add.email'))">{{ errors.first($t('user.add.email')) }}</span>
        <span class="text-danger text-sm" v-if="Duplicate>0">Email Already Exist!</span>

        <!-- PHONE -->
        <vs-input :label="$t('user.add.phone_no')" v-model="dataPhone" @input="acceptNumber" class="mt-5 w-full" :name="$t('user.add.phone_no')"  />
        <span class="text-danger text-sm" v-show="errors.has($t('user.add.phone_no'))">{{ errors.first($t('user.add.phone_no')) }}</span><br>
        <span v-if="dataPhone.length > 0 &&  dataPhone.length < 14" class="text-danger text-sm">Invalid phone number format.</span>
        <!-- <vs-row class="mb-5 ml-1">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="6">
        <label>{{ $t('user.add.status') }}</label>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="6">
           <vs-switch v-model="pending"></vs-switch>
        </vs-col>
        </vs-row> -->
        <vs-row class="mb-5 ml-1">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="6">
        <label>{{ $t('user.add.emergency_contact') }}</label>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="6">
          <vs-switch v-model="dataCamEcontact"></vs-switch>
        </vs-col>
        </vs-row>
         <!-- <vs-row class="mb-10 ml-1">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="6">
        <label>{{ $t('user.add.status') }}</label>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="6">
           <vs-switch v-model="dataStatus"></vs-switch>
        </vs-col>
        </vs-row> -->
      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click.native="submitData" :disabled="!isFormValid">Submit</vs-button>
      <vs-button type="border" color="danger" @click.native="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>

</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import {
  UPDATE_USER,
  SINGLE_USER_BY_EMAIL,
  CHECK_USER_NAME_EXCEPT_ID,
  UPLOAD_IMAGE,
  UPDATE_STUDENT_USER,
  CREATE_USER_ACTIVITY,
  CHECK_USER_EMAIL
} from '@/graphql'
import S3 from 'aws-s3'
const config = {
  bucketName: process.env.VUE_APP_AWS_BUCKET,
  region: process.env.VUE_APP_AWS_DEFAULT_REGION,
  accessKeyId: process.env.VUE_APP_AWS_ACCESS_KEY_ID,
  secretAccessKey: process.env.VUE_APP_AWS_SECRET_ACCESS_KEY,
  s3Url: process.env.VUE_APP_AWS_s3Url,
  dirName: process.env.VUE_APP_AWS_DIREC+'/UserImage',
}
const S3Client = new S3(config)
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar

  },
  data () {
    return {
      Duplicate:0,
      UserDuplicate:0,
      alphanumeric:0,
      dataId: null,
      dataStudentId:null,
      dataUserName: '',
      dataFirstName: '',
      dataMiddleName: '',
      dataLastName: '',
      dataStudentName: '',
      dataImg : null,
      dataEmail: '',
      dataPhone: '',
      dataStudent: '',
      dataStatus: '',
      dataConf:'',
      pending:'',
      dataCamEcontact:'',
      ImgName:null,
      img_cdn:process.env.VUE_APP_AWS_s3Url+"/",
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  watch: {
    isSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      } else {
        const { student, camuser } = JSON.parse(JSON.stringify(this.data))
        console.log(camuser)
        this.dataId = camuser.id
        this.dataStudentId = student.id
        this.dataUserName = camuser.username
        this.dataFirstName = camuser.fname
        this.dataMiddleName = camuser.middle_name
        this.dataLastName = camuser.lname
        this.ImgName = camuser.avatar
        this.dataImg = this.img_cdn + camuser.avatar
        this.dataEmail = camuser.email
        this.dataPhone = camuser.phone
        this.dataStatus = camuser.status
        this.dataCamEcontact = camuser.pivot.emergency_contact
        this.pending = camuser.pending
        this.dataConf = camuser.email_confirmed
        if (!this.dataPhone) {
          this.dataPhone = ''
        }

      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          this.$validator.reset()
          this.initValues()
        }
      }
    },
    isFormValid () {
      return !this.errors.any() && this.dataFirstName && this.dataEmail && (this.dataPhone == '' || this.dataPhone.length == 14)
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    openLoadingInDiv () {
      this.$vs.loading({
        type:'sound',
        container: '#div-with-loading',
        scale: 0.6
      })
    },
    UpdateSuccess () {
      this.$emit('getdata', true)
      this.$vs.notify({
        title: this.$t('user.alert_title'),
        text: 'Update Successfully!',
        color: 'success',
        position: 'top-right'
      })

    },
    UpdateFail () {
      this.$vs.notify({
        title: this.$t('user.alert_title'),
        text: 'Failed to Update!',
        color: 'danger',
        position: 'top-right'
      })
    },
    initValues () {
      if (this.dataId) return
      this.dataId = null
      this.dataStudentId = null
      this.dataUserName = ''
      this.dataFirstName = ''
      this.dataMiddleName = ''
      this.dataLastName = ''
      this.dataStudentName = ''
      this.dataStudent = ''
      this.dataStatus = ''
      this.dataEmail = ''
      this.dataPhone = ''
      this.dataEcontact = ''
      this.dataConf = ''
      this.ImgName = null
      this.dataImg = null
    },
    submitData () {
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.dataId !== null && this.dataId >= 0) {
            this.$apollo
              .mutate({
                mutation: UPDATE_STUDENT_USER,
                variables: {
                  id :this.dataId,
                  fname:this.dataFirstName,
                  middle_name:this.dataMiddleName,
                  lname: this.dataLastName,
                  username: this.dataUserName,
                  phone:this.dataPhone,
                  email :this.dataEmail,
                  email_confirmed:this.dataConf,
                  pending:this.pending,
                  emergency_contact:this.dataCamEcontact,
                  status:this.dataStatus,
                  avatar: this.ImgName,
                  student_id :this.dataStudentId
                }
              })
              .then(response => {
                if (response.data.updateStudentUser.status == 'SUCCESS') {
                  this.UpdateSuccess()
                  this.userActivity()
                }
              }).catch(error => {
                this.UpdateFail()
                console.log(error)
              })
            // this.$store.dispatch('dataList/updateStudent', obj).catch(err => { console.error(err) })
          }
          this.$emit('closeSidebar')
          this.initValues()
        }
      })
    },
    acceptEmail () {
      if (this.dataId !== null && this.dataId >= 0) {
        this.checkEmailExceptId()
      } else {
        this.checkEmailWithoutId()
      }
    },
    checkEmailExceptId () {
      this.$apollo
        .mutate({
          mutation: CHECK_USER_EMAIL,
          variables: {
            id: this.dataId,
            email: this.dataEmail
          }
        })
        .then(response => {
          this.Duplicate = response.data.checkUserEmail.length
        })
    },
    checkEmailWithoutId () {
      this.$apollo
        .mutate({
          mutation: SINGLE_USER_BY_EMAIL,
          variables: {
            email: this.dataEmail
          }
        })
        .then(response => {
          this.Duplicate = response.data.userByEmail.length
        })
    },
    userActivity () {
      this.$apollo
        .mutate({
          mutation: CREATE_USER_ACTIVITY,
          variables: {
            object_id: this.dataId,
            object_type:'App\\Models\\User',
            activity:'updated'
          }
        })
    },
      checkUserNameExcepteId(){
      if(this.dataUserName.length>0){
        this.$apollo
          .mutate({
            mutation: CHECK_USER_NAME_EXCEPT_ID,
            variables: {
              id: this.dataId,
              username: this.dataUserName
            }
          })
          .then(response => {
            this.UserDuplicate = response.data.checkUserNameExceptId.length
          })
      }
      else{
        this.dataUserName=''
        this.UserDuplicate = 0
      }
   },
    // checkUserName () {
    //   const letterNumber = /[^a-zA-Z0-9]/g
    //   if (this.dataUserName.match(letterNumber)) {
    //     this.alphanumeric = 1
    //   } else if (this.dataUserName) {
    //     this.alphanumeric = 0
    //     this.$apollo
    //       .mutate({
    //         mutation: SINGLE_USER_BY_USERNAME,
    //         variables: {
    //           username: this.dataUserName
    //         }
    //       })
    //       .then(response => {
    //         this.UserDuplicate = response.data.userByUserName.length
    //       })
    //   }
    // },
     updateCurrImg (input) {
          const file = input.target.files[0]
          const name = Math.random().toString().slice(2)
          this.openLoadingInDiv()
          S3Client.uploadFile(file, name)
            .then(response => {
              this.ImgName = response.key
              this.dataImg = this.img_cdn+response.key
              this.$vs.loading.close('#div-with-loading > .con-vs-loading')
            })
            .catch(err => console.error(err))
      },
    // updateCurrImg (input) {
    //   if (input.target.files && input.target.files[0]) {
    //     this.checkImg = 'somthing'
    //     const reader = new FileReader()
    //     reader.onload = e => {
    //       this.dataImg = e.target.result
    //       this.openLoadingInDiv()
    //       this.$apollo
    //         .mutate({
    //           mutation: UPLOAD_IMAGE,
    //           variables: {
    //             image:this.dataImg,
    //             oldimage:this.oldimage
    //           }
    //         })
    //         .then(response => {
    //           if (response) {
    //             this.oldimage = ''
    //             if (response.data.uploadImage.status == 'SUCCESS') {
    //               this.ImgName = response.data.uploadImage.image_name
    //               this.$vs.loading.close('#div-with-loading > .con-vs-loading')
    //             } else {
    //               this.ImgName = response.data.uploadImage.image_name
    //               this.UploadFail(response.data.uploadImage.error)
    //               this.$vs.loading.close('#div-with-loading > .con-vs-loading')
    //             }

    //           }
    //         }).catch(error => {
    //           console.log(error)
    //         })
    //     }
    //     reader.readAsDataURL(input.target.files[0])
    //   }
    // },
    acceptNumber () {
      const x = this.dataPhone
        .replace(/\D/g, '')
        .match(/(\d{0,3})(\d{0,4})(\d{0,3})/)

      this.dataPhone = !x[2]
        ? x[1]
        : `(${  x[1]  }) ${  x[2]  }${x[3] ? `-${  x[3]}` : ''}`
    }
  },
  created () {
    
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
}
</style>
